import { render, staticRenderFns } from "./mapa-demanda.vue?vue&type=template&id=46ff38fe&scoped=true&"
import script from "./mapa-demanda.vue?vue&type=script&lang=js&"
export * from "./mapa-demanda.vue?vue&type=script&lang=js&"
import style0 from "./mapa-demanda.vue?vue&type=style&index=0&id=46ff38fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff38fe",
  null
  
)

export default component.exports